import Hero from './components/Hero';
import Mission from './components/Mission';
import Expertise from './components/Expertise';
import Approach from './components/Approach';
import Principles from './components/Principles';
import Contact from './components/Contact';

export default function Home() {
  return (
    <main>
      <Hero />
      <Mission />
      <Expertise />
      <Approach />
      <Principles />
      <Contact />
    </main>
  );
}